import React from 'react';
import { motion } from 'framer-motion';
import { Shovel, Gamepad, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'We Dig Deep',
    desc: 'Our curators (Zephyrine, Cosimo, Eulalia) scour the obscure corners of the web.',
    icon: <Shovel className="w-10 h-10 text-brand-offwhite" data-id="element-100" />,
    bg: 'bg-brand-navy'
  }, {
    num: '02',
    title: 'We Play Everything',
    desc: "100+ hours of testing. If it's boring, it's banished. Only the extraordinary survive.",
    icon: <Gamepad className="w-10 h-10 text-brand-navy" data-id="element-101" />,
    bg: 'bg-brand-lime'
  }, {
    num: '03',
    title: 'You Discover Magic',
    desc: 'Weekly curated drops of games that will change how you see the medium.',
    icon: <Sparkles className="w-10 h-10 text-brand-navy" data-id="element-102" />,
    bg: 'bg-brand-pink'
  }];
  return <section className="py-24 bg-brand-yellow border-y-4 border-brand-navy" data-id="element-103">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-104">
        <div className="text-center mb-16" data-id="element-105">
          <h2 className="text-5xl font-display font-black text-brand-navy" data-id="element-106">
            The Method to Our <span className="italic" data-id="element-107">Madness</span>
          </h2>
        </div>

        <div className="relative" data-id="element-108">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-2 bg-brand-navy -translate-y-1/2 z-0 border-t-2 border-b-2 border-brand-navy border-dashed" data-id="element-109"></div>

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-110">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-111">
                <div className={`w-24 h-24 ${step.bg} border-4 border-brand-navy flex items-center justify-center mb-6 shadow-quirky transform transition-transform hover:scale-110 hover:rotate-6`} data-id="element-112">
                  {step.icon}
                </div>
                <div className="bg-white border-4 border-brand-navy p-6 w-full shadow-quirky min-h-[200px] flex flex-col items-center" data-id="element-113">
                  <span className="text-4xl font-display font-black text-brand-navy/20 mb-2" data-id="element-114">
                    {step.num}
                  </span>
                  <h3 className="text-2xl font-display font-bold text-brand-navy mb-3" data-id="element-115">
                    {step.title}
                  </h3>
                  <p className="font-body text-brand-navy/80" data-id="element-116">{step.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}